const translatableTextDefault = require("@core/layouts/components/input-fields/translatable-text-field/defaultObject.js");
module.exports = {
  title: JSON.parse(JSON.stringify(translatableTextDefault.default)),
  subtitle: JSON.parse(JSON.stringify(translatableTextDefault.default)),
  description: JSON.parse(JSON.stringify(translatableTextDefault.default)),
  examples: [],
  imageUrl: JSON.parse(JSON.stringify(translatableTextDefault.default))
};
